<script setup>
import ButtonWithSpinner from "@/components/forms/SharedComponents/ButtonWithSpinner.vue";
import { useRouter } from "vue-router";
import Card from "primevue/card";
import ArrowRight from "@/components/shared/icons/ArrowRight.vue";
import { HOME_CARDS, WHAT_TO_EXPECT_CARDS } from "../constants";
import { CARDS_1, CARDS_2 } from "../styles";

const router = useRouter();

const handleActionButtonClick = async () => {
  await router.push({ name: "curriculum-integration-dashboard" });
};
</script>

<template>
  <div class="max-w-[980px]">
    <h2 class="text-left font-bold text-xl md:text-4xl">
      Welcome to the
      <span class="text-2xl block md:text-5.5xl md:font-extrabold"
        >CURRICULUM INTEGRATION APP!</span
      >
    </h2>
    <section
      id="welcome-info"
      class="w-full font-montserrat text-indigo-base md:flex md:flex-row-reverse md:justify-end"
    >
      <div class="md:w-full">
        <img src="/images/api_curriculum_integration_1.png" class="w-full" />
      </div>
      <div class="w-full px-3 md:max-w-md">
        <p class="py-5 text-base font-medium pb-9">
          In an increasingly interconnected world, the demand to
          internationalize the student experience is stronger than ever. Click
          below to get started with the Curriculum Integration App which will
          allow you to analyze potential course matches using AI across a global
          course library to find best fit equivalencies.
        </p>
        <ButtonWithSpinner
          id="getStartedButton"
          ref="getStartedButton"
          data-testid="get-started-button"
          type="submit"
          variant="secondary"
          variant-type="block"
          button-height="min-h-[58px] md:min-h-[60px] mt-4"
          class="md:max-w-[188px]"
          @click="handleActionButtonClick"
        >
          <div
            class="flex justify-center items-center text-lg md:text-base md:font-bold"
          >
            <span class="pr-3 uppercase">
              Get started
            </span>
            <ArrowRight custom-class="w-4 h-4" />
          </div>
        </ButtonWithSpinner>
      </div>
    </section>
    <section
      id="middle-info"
      class="bg-teal-light px-4 py-6 my-10 text-base font-montserrat font-medium leading-snug md:p-8"
    >
      <div class="bg-transparent mb-6 text-center">
        Achieving this goal requires a strategic, collaborative approach between
        international education professionals and faculty across disciplines.
        <span class="font-semibold"
          >Curriculum Integration helps bridge this gap by:</span
        >
      </div>
      <div class="grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 gap-6">
        <Card v-for="card in HOME_CARDS" :key="card.title" :pt="CARDS_1">
          <template #title>
            <component :is="card.icon" class="mb-3.5 w-10 h-10" />
            <p class="font-semibold text-lg mb-3.5">
              {{ card.title }}
            </p>
          </template>
          <template #content>
            <p class="text-base font-medium">
              {{ card.description }}
            </p>
          </template>
        </Card>
      </div>
    </section>
    <section id="what-can-you-expect" class="">
      <h2 class="text-center font-bold text-xl leading-loose">
        What Can You Expect?
      </h2>
      <p class="mb-6 text-center font-medium text-base leading-snug">
        Our Curriculum Integration resource equips you with:
      </p>
      <div class="md:flex">
        <div id="dashboard-image-container" class="w-full max-w-[454px]">
          <img src="/images/dashboard-screen.png" class="w-full" />
        </div>
        <div id="what-to-expect-cards">
          <Card
            v-for="card in WHAT_TO_EXPECT_CARDS"
            :key="card.title"
            :pt="CARDS_2"
          >
            <template #content>
              <div>
                <component :is="card.icon" class="w-10 h-10 mr-2" />
              </div>
              <div>
                <p class="font-semibold text-lg">
                  {{ card.title }}
                </p>
                <p class="text-base font-medium">
                  {{ card.description }}
                </p>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </section>
    <section id="footer" class="bg-gray-25 px-4 py-6 mt-10 flex justify-center">
      <div class="max-w-[745px] text-center md:h-56">
        <h2 class="mb-6 font-bold text-xl leading-loose">
          Ready to dive in?
        </h2>
        <p class="mb-6 font-medium text-base leading-snug">
          Click below to explore courses and discover how you can champion
          global learning at your institution. Together, let’s make experiential
          learning a vital and accessible part of every student’s academic
          journey.
        </p>
        <ButtonWithSpinner
          id="getStartedButton2"
          ref="getStartedButton2"
          data-testid="get-started-button-2"
          type="submit"
          variant="secondary"
          variant-type="block"
          button-height="min-h-[58px] md:min-h-[60px]"
          class="md:max-w-[188px]"
          @click="handleActionButtonClick"
        >
          <div
            class="flex justify-center items-center text-lg md:text-base md:font-bold"
          >
            <span class="pr-3 uppercase">
              Get started
            </span>
            <ArrowRight custom-class="w-4 h-4" />
          </div>
        </ButtonWithSpinner>
      </div>
    </section>
  </div>
</template>
